/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for caseSensitivityMode. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="caseSensitivityMode"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="caseSensitive"/&gt; &lt;enumeration value="caseInsensitive"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class CaseSensitivityMode extends Enum{

	enumValue = null;

	static  CASE_SENSITIVE = CaseSensitivityMode.newLiteral("caseSensitive");

	static  CASE_INSENSITIVE = CaseSensitivityMode.newLiteral("caseInsensitive");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < CaseSensitivityMode.values().length); ++i) {
			if (CaseSensitivityMode.values()[i].enumValue == v) {
				return CaseSensitivityMode.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("CaseSensitivityMode" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/CaseSensitivityMode.js